export const DOWNLOAD_TYPES = {
  TESTIGOS: {
    value: 1,
    label: 'Testigos'
  },
  SABANAS: {
    value: 2,
    label: 'Sábanas'
  },
  TODO: {
    value: 3,
    label: 'Testigos y sábanas'
  },
  DINAMICOS: {
    value: 4,
    label: 'Reporte Dinámico'
  }
};
